'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$() {
  this.aNL = null;
  this.aO2 = null;
  this.aNO = null;
  this.aNP = false;
  this.aNU = null;
  this.aNV = false;
  this.aO0 = null;
  this.aO1 = false;
  this.aNM = null;
  this.aNN = false;
  this.aNY = null;
  this.aNZ = false;
  this.aNW = null;
  this.aNX = false;
  this.aNQ = null;
  this.aNR = false;
  this.aNS = null;
  this.aNT = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ = this;
  this.aNL = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$();
  this.aO2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$.prototype = $p;
$p.eR = (function() {
  return this.aNL;
});
$p.eO = (function() {
  return this.aO2;
});
$p.bW = (function() {
  if ((!this.aNP)) {
    this.aNO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aNP = true;
  }
  return this.aNO;
});
$p.b9 = (function() {
  if ((!this.aNV)) {
    this.aNU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aNV = true;
  }
  return this.aNU;
});
$p.b3 = (function() {
  if ((!this.aO1)) {
    this.aO0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aO1 = true;
  }
  return this.aO0;
});
$p.aG = (function() {
  if ((!this.aNN)) {
    this.aNM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aNN = true;
  }
  return this.aNM;
});
$p.az = (function() {
  if ((!this.aNZ)) {
    this.aNY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aNZ = true;
  }
  return this.aNY;
});
$p.aY = (function() {
  if ((!this.aNX)) {
    this.aNW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aNX = true;
  }
  return this.aNW;
});
$p.E8 = (function() {
  if ((!this.aNR)) {
    this.aNQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Origin of Goods";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aNR = true;
  }
  return this.aNQ;
});
$p.bsk = (function() {
  if ((!this.aNT)) {
    this.aNS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aNT = true;
  }
  return this.aNS;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$, "app.data.data_point_types$package$OriginOfGoodsForm$", ({
  Gb: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$() {
  this.aNJ = null;
  this.aNK = false;
  this.aNH = null;
  this.aNI = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$.prototype = $p;
$p.aA = (function() {
  if ((!this.aNK)) {
    this.aNJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aNK = true;
  }
  return this.aNJ;
});
$p.bs2 = (function() {
  if ((!this.aNI)) {
    this.aNH = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoodsForm$().E8();
    this.aNI = true;
  }
  return this.aNH;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$, "app.data.data_point_types$package$OriginOfGoods$", ({
  Ga: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$OriginOfGoods$ };
//# sourceMappingURL=app.data.data_point_types$package$-Origin-Of-Goods$.js.map
